export default function PhoneMockup({ alt }) {
  return (
    <div className="relative flex justify-center items-end gap-4 py-6" data-testid="hero-phone-mockup">
      <PhoneFrame src="/screens/factures.png" alt={alt} className="hidden md:block w-[200px] -rotate-6 translate-y-6 opacity-95" />
      <PhoneFrame src="/screens/accueil.png" alt={alt} className="w-[230px] sm:w-[260px] z-10" priority />
    </div>
  );
}

function PhoneFrame({ src, alt, className = "", priority = false }) {
  return (
    <div className={`rounded-[2.4rem] bg-[#1C1C1C] p-[9px] shadow-2xl ring-1 ring-black/10 ${className}`}>
      <div className="rounded-[1.9rem] overflow-hidden bg-white aspect-[390/844]">
        <img src={src} alt={alt} loading={priority ? "eager" : "lazy"} className="w-full h-full object-cover object-top" />
      </div>
    </div>
  );
}
